import React, { Component } from 'react';
import Navbar from '../../../../_components/common/Navbar';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';
import TableNew from '../../../../_components/common/TableNew';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import {  tables } from './tableData';
import { getReportContentAction } from '../../../../_actions';
import CustomTableNew from '../../../../_components/common/CustomTableNew';
import vviGraphSlotMap from '../../../../images/vviGraphSlotMap.svg';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';



class ReportDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportName: '',
            reportType: '',
            orientationId: 'null',
            showTable: false,
            orientationname: '',
            slotId: 'null',
            infoModal: false,
            slotTextValue: null,
        }
    }

    componentDidMount() {

        let setPassWordHashCode = this.props.location.pathname.split('/');


      

       
        this.setState({
            reportName: setPassWordHashCode[setPassWordHashCode.length - 1],
            reportType: setPassWordHashCode[setPassWordHashCode.length - 2]
        })
        const data = {
            'reportContent': setPassWordHashCode[setPassWordHashCode.length - 1],
        }

        setPassWordHashCode[setPassWordHashCode.length - 1] === 'orientation-text' &&
            this.props.dispatch(getReportContentAction.reportContentHandler(data, 'vpi'))


        this.props.dispatch(getReportContentAction.getOrientationListHandler());

        setPassWordHashCode[setPassWordHashCode.length - 1] === 'slot-text' &&
            this.props.dispatch(getReportContentAction.getSlotListHandler())

    }

    onClickInfo = () => {
        this.setState({
            infoModal: !this.state.infoModal
        })
    }

    onChangeSlot = (ev) => {
        if (ev.target.value === 'null') {
            this.setState({
                showTable: false,
            })
        }
        if (ev.target.value !== 'null') {
            this.setState({
                showTable: true,
                slotTextValue: ev.target.value
            })
            const data = {
                'reportContent': this.state.reportName,
                'orientationId': ev.target.value
            }
            this.props.dispatch(getReportContentAction.reportContentHandler(data, 'vvi'))

        }
        this.setState({
            slotId: ev.target.value,
            orientationname: this.getOrientationname(ev.target.value)
        })



       
    }

    onChangeOrientation = (ev) => {
        if (ev.target.value === 'null') {
            this.setState({
                showTable: false,
            })
        }

        if (ev.target.value !== 'null') {
            this.setState({
                showTable: true,
            })
            const data = {
                'reportContent': this.state.reportName === 'implications' ? 'implication' : this.state.reportName === 'action-items' ? 'actionitems' : this.state.reportName,
                'orientationId': ev.target.value
            }
            this.props.dispatch(getReportContentAction.reportContentHandler(data, this.state.reportType))

        }

        this.setState({
            orientationId: ev.target.value,
            orientationname: this.getOrientationname(ev.target.value)
        })

    }

    getOrientationname = (id) => {

        for (let i = 0; i < this.reformatOrientationList(this.props.getOrientationListResponse).length; i++) {
            if (this.props.getOrientationListResponse[i].id === +id) {
                return this.props.getOrientationListResponse[i].orientation_name;
            }
        }
    }

    getActionItemsData = () => {
        const data = [];
        for (let i in this.props.getReportContentResponse) {
            this.props.getReportContentResponse[i].high_text &&
                data.push({
                    'attribute': this.props.getReportContentResponse[i].attribute__attribute_name,
                    'code': 'High',
                    'text': <div>
                        {require('html-react-parser')(
                            this.props.getReportContentResponse[i].high_text
                        )}
                    </div>,
                })

            this.props.getReportContentResponse[i].medium_text &&
                data.push({
                    'attribute': this.props.getReportContentResponse[i].attribute__attribute_name,
                    'code': 'Medium',
                    'text': <div>
                        {require('html-react-parser')(
                            this.props.getReportContentResponse[i].medium_text
                        )}
                    </div>,
                })

            this.props.getReportContentResponse[i].low_text &&
                data.push({
                    'attribute': this.props.getReportContentResponse[i].attribute__attribute_name,
                    'code': 'Low',
                    'text': <div>
                        {require('html-react-parser')(
                            this.props.getReportContentResponse[i].low_text
                        )}
                    </div>,
                })
        }
        return data
    }

    getImplicationsData = (report) => {
       
        const data = [];
        for (let i in this.props.getReportContentResponse) {
            if (this.props.getReportContentResponse[i].compare_attribute__attribute_name + ' (vs) ' + this.props.getReportContentResponse[i].attribute__attribute_name === report) {

                if (this.props.getReportContentResponse[i].compare_with === 1) {
                    data.push({
                        'code': 'HH',
                        'text': this.props.getReportContentResponse[i].high_text,

                    })
                    data.push({
                        'code': 'HM',
                        'text': this.props.getReportContentResponse[i].medium_text,

                    })
                    data.push({
                        'code': 'HL',
                        'text': this.props.getReportContentResponse[i].low_text,

                    })
                }
                if (this.props.getReportContentResponse[i].compare_with === 2) {
                    data.push({
                        'code': 'MH',
                        'text': this.props.getReportContentResponse[i].high_text,
                    })
                    data.push({
                        'code': 'MM',
                        'text': this.props.getReportContentResponse[i].medium_text,

                    })
                    data.push({
                        'code': 'ML',
                        'text': this.props.getReportContentResponse[i].low_text,

                    })
                }
                if (this.props.getReportContentResponse[i].compare_with === 3) {
                    data.push({
                        'code': 'LH',
                        'text': this.props.getReportContentResponse[i].high_text,

                    })
                    data.push({
                        'code': 'LM',
                        'text': this.props.getReportContentResponse[i].medium_text,
                    })
                    data.push({
                        'code': 'LL',
                        'text': this.props.getReportContentResponse[i].low_text,
                    })
                }
            }
        }
        return data
    }

  

    getReportData = (reportName) => {

        if (reportName === 'inference') {
            return (
                this.props.getReportContentResponse.map(
                    (report, i) => {
                        return (
                            this.state.showTable === true &&
                            <React.Fragment key={i}>
                                <div className="bg-green rounded-top position-relative mt-5 mb-3 animation-fade-in" >
                                    <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> {report.orientation__reference_attribute__attribute_name}</p>
                                </div >
                                <CustomTableNew
                                    data={[{
                                        'code': 'H',
                                        'inference_text': report.high_text
                                        // <div>
                                        //     {require('html-react-parser')(
                                        //         '<blockquote><p>&quot;If your dreams don&#39;t scare you, they aren&#39;t big enough.&quot; - Ellen Johnson Sirleaf </p></blockquote><p>You&#39;ve some dreams and aspirations, but you don&#39;t seem to push yourself to take on higher challenges. Ask yourself:</p><ul><li>Are my goals good enough to bring out the best in me? Is that all I&#39;m capable of achieving?</li><li>If I were to assume that I just achieved all my goals, would I be contented or seek something more? What more?</li><li>If I were to stay focused and make the best use of my abilities, what all can I accomplish in life? Why am I not aiming for it?</li><li>What&#39;s holding me back from pursuing bigger goals? Am I ready to address those blocks? How might I need to change?</li></ul>'
                                        //     )}
                                        // </div>
                                    }, {
                                        'code': 'M',
                                        'inference_text': report.medium_text
                                    }, {
                                        'code': 'L',
                                        'inference_text': report.low_text
                                    }]}
                                    columns={tables.inference}
                                    showSlNo="false"
                                    noPointerClass={true}
                                // textAlign="center"
                                />

                            </React.Fragment>

                        )
                    }
                )

            )
        }
        if (reportName === 'implications') {
            const attributeHeader = [];
            this.props.getReportContentResponse.map(
                (report, i) => {
                    let flag = 0;
                    for (let j in attributeHeader) {
                        if ((attributeHeader[j] === report.compare_attribute__attribute_name + ' (vs) ' + report.attribute__attribute_name)) {
                            flag = 1
                        }
                    }
                    if (flag === 0) {
                        attributeHeader.push(report.compare_attribute__attribute_name + ' (vs) ' + report.attribute__attribute_name)
                    }
                })
            return (
                attributeHeader.map(
                    (report, i) => {
                        return (
                            this.state.showTable === true &&
                            <React.Fragment key={i}>
                                <div className="bg-green rounded-top position-relative mt-5 mb-1 animation-fade-in" >
                                    <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> {report}</p>
                                </div>
                                <CustomTableNew
                                    data={this.getImplicationsData(report)}
                                    columns={tables.implications}
                                    showSlNo="false"
                                    noPointerClass={true}
                                // textAlign="center"
                                />
                            </React.Fragment>
                        )
                    }
                )
            )
        }

        if (reportName === 'action-items') {
            return (
                this.state.showTable === true && this.props.getReportContentResponse.length !== 0 &&
                <React.Fragment>
                    <CustomTableNew
                        data={this.getActionItemsData()}
                        columns={tables.actionItems}
                        showSlNo="false"
                        noPointerClass={true}
                    // textAlign="center"
                    />
                </React.Fragment>
            )
        }
    }

    reformatOrientationList =(response)=>{
        let returnData = [];
        response.map(
            (data,i)=>{
                (data.orientation_name!=='Vision'&&data.orientation_name!=='Value')&&
                returnData.push(data)
            }
        )
    
        return returnData
    }

    render() {
        const { getOrientationListLoading, getOrientationListResponse, getReportContentResponse, getReportContentLoading } = this.props;
        const reportData = (this.state.reportName !== 'orientation-text' && !getReportContentLoading && getReportContentResponse !== undefined) ? this.getReportData(this.state.reportName) : '';
        const reportName = this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1];
       

        return (
            < div >
                <Navbar />

                <div className="container custom-container my-5" >
                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                },
                                {
                                    link: '/admin/app/edit-report',
                                    name:'REPORT CONTENT'
                                }, {
                                    link: '',
                                    name: reportName.toUpperCase()
                                }
                            ]}
                        />
                    </div>

                    <div className="bg-green rounded-top position-relative animation-fade-in">
                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> {reportName}</p>
                        {
                            getOrientationListLoading &&
                            <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                        }
                    </div>

                    {
                        reportName !== 'orientation-text' && reportName !== 'slot-text' &&
                        <div className="d-flex flex-row flex-wrap align-items-center">
                            <div className="col-md-6 col-12 px-0 my-2">
                                <div className="d-flex flex-row justify-content-md-around justify-content-between">
                                    <span className="col-3 mt-2" > Orientations &nbsp;
                                	{
                                            getOrientationListLoading &&
                                            <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                        }
                                    </span>

                                    <Input
                                        value={this.state.orientationId}
                                        type="select" name="field"
                                        bsSize="sm" className="col-6 border-1"
                                        onChange={this.onChangeOrientation}
                                    >
                                        <option value='null' key={0}>Choose an orientation</option>;

                                    } */}
                                        {
                                            this.props.getOrientationListLoading === false &&
                                            this.reformatOrientationList(this.props.getOrientationListResponse).map(
                                                (data, i) => {
                                                    return <option value={data.id} key={i}>{data.orientation_name}</option>;
                                                }
                                            )
                                        }

                                    </Input>
                                </div>
                            </div>
                        </div>

                    }
                    {
                        reportName === 'orientation-text' &&
                        <TableNew
                            data={getOrientationListLoading === false ? this.reformatOrientationList(getOrientationListResponse) : ''}
                            columns={tables.orientation}
                            showSlNo="false"
                        // sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                        // sortType={this.state.sortType}
                        />
                    }

                    {reportData}

                    {
                        reportName === 'slot-text' &&
                        <React.Fragment>
                            <div className="d-flex flex-row flex-wrap align-items-center">
                                <div className="col-md-6 col-12 px-0 my-2">
                                    <div className="d-flex flex-row justify-content-md-around justify-content-between animation-fade-in">
                                        <span className="col-3 mt-2" > Slots &nbsp;
                                    {
                                                getOrientationListLoading &&
                                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                            }
                                        </span>
                                        <Input
                                            value={this.state.slotTextValue}
                                            type="select" name="field"
                                            bsSize="sm" className="col-6 border-1"
                                            onChange={this.onChangeSlot}
                                        >
                                            <option value='null' key={0}>Choose Slot</option>;
                                        {
                                                this.props.getSlotListLoading === false &&
                                                this.props.getSlotListResponse.map(
                                                    (data, i) => {
                                                        return <option value={data.slot_name} key={i}>{data.slot_name}</option>;
                                                    }
                                                )
                                            }

                                        </Input>
                                        <span className="col-3 mt-2" >
                                            <i onClick={this.onClickInfo} className="fas fa-info-circle"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                {
                                    !getReportContentLoading && this.state.showTable === true &&
                                    <h3 className="mt-5">Slot No:{this.state.slotTextValue}</h3>
                                }

                                {
                                    !getReportContentLoading && this.state.showTable === true &&
                                    <React.Fragment>
                                        {
                                            getReportContentResponse.map(
                                                (data, i) => {
                                                    return <div>
                                                        {
                                                            data.slot_type === 'Orientation indicator' &&
                                                            data.slot_description
                                                        }

                                                        {
                                                            data.slot_type !== 'Orientation indicator' &&
                                                            <div className="mt-5 animation-fade-in">
                                                                <p>{data.slot_type}</p>
                                                                {require('html-react-parser')(
                                                                    data.slot_description
                                                                )}
                                                            </div>

                                                        }
                                                    </div>
                                                }
                                            )

                                        }
                                    </React.Fragment>
                                }
                            </div>
                        </React.Fragment>
                    }

                    {
                        getReportContentLoading && this.state.showTable === true &&
                        <p className=" mt-2 text-black text-center"> <i className="fas fa-spinner fa-spin   spinner-position " ></i>&nbsp;Loading
                        </p>
                    }

                    {
                        this.state.reportName !== 'orientation-text' && getReportContentLoading === false && getReportContentResponse !== undefined && getReportContentResponse.length === 0 && this.state.orientationId !== 'null' &&
                        <p className="h6 text-center">No Data Available</p>
                    }

                    {
                        this.state.infoModal &&
                        <Modal
                            isOpen={this.state.infoModal}
                            centered={true}
                        >
                            <ModalHeader
                                toggle={this.onClickInfo} className="bg-black text-white custom-header" >SLOT MAP</ModalHeader>
                            <ModalBody>
                                <div>
                                    <img className="img-fluid" src={vviGraphSlotMap} />
                                </div>
                                <ModalFooter className="justify-content-center pb-0" >
                                    <button onClick={this.onClickInfo} className="bg-black text-white btn-sm " type="submit">CLOSE</button>
                                </ModalFooter>
                            </ModalBody>
                        </Modal>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
   

    const { getOrientationListLoading } = state.getOrientationList;
    const getOrientationListError = state.getOrientationList.error;
    const getOrientationListResponse = (!getOrientationListLoading && !getOrientationListError) ? state.getOrientationList.data.data.results : '';

    const { getReportContentLoading } = state.getReportContent;
    const getReportContentError = state.getReportContent.error;
    const getReportContentResponse = (!getReportContentLoading && !getReportContentError) ? state.getReportContent.data.data.response : '';

    const { getSlotListLoading } = state.getSlotList;
    const getSlotListError = state.getSlotList.error;
    const getSlotListResponse = (!getSlotListLoading && !getSlotListError) ? state.getSlotList.data.data.response : '';

    return {
        getOrientationListLoading,
        getOrientationListResponse,

        getReportContentLoading,
        getReportContentResponse,

        getSlotListLoading,
        getSlotListResponse
    };
}

export default connect(mapStateToProps)(ReportDetails);


// WEBPACK FOOTER //
// ./src/_pages/Admin/ReportContent/ReportDetails/index.jsx